import { forwardRef } from 'react';

import { StyledEditorToolbar } from './styles';

// ----------------------------------------------------------------------

const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];

export const formats = [
  'align',
  'blockquote',
  'bold',
  'bullet',
  'code',
  'code-block',
  'color',
  'direction',
  'font',
  'header',
  'indent',
  'italic',
  'link',
  'list',
  'size',
  'strike',
  'underline',
];

type EditorToolbarProps = {
  id: string;
  simple?: boolean;
  noHeader?: boolean;
};

/**
 * The inner `<div id={id}>` is the element Quill takes over as its toolbar. It is forwarded so
 * `Editor` can hand Quill the node itself rather than a `#id` selector: Quill resolves a selector
 * with `document.querySelector`, so a second editor sharing the id was handed the FIRST one's
 * toolbar and died part-way through start-up (JT1-1726).
 */
const Toolbar = forwardRef<HTMLDivElement, EditorToolbarProps>(
  ({ id, simple, noHeader, ...other }, ref) => (
    <StyledEditorToolbar {...other}>
      <div id={id} ref={ref}>
        {noHeader && (
          <div className="ql-formats">
            <select className="ql-header" defaultValue="">
              {HEADINGS.map((heading, index) => (
                <option key={heading} value={index + 1}>
                  {heading}
                </option>
              ))}
              <option value="">Normal</option>
            </select>
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-bold" />
          <button type="button" className="ql-italic" />
          <button type="button" className="ql-underline" />
          <button type="button" className="ql-strike" />
        </div>

        {!simple && (
          <div className="ql-formats">
            <select className="ql-color" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-list" value="ordered" />
          <button type="button" className="ql-list" value="bullet" />
          {!simple && <button type="button" className="ql-indent" value="-1" />}
          {!simple && <button type="button" className="ql-indent" value="+1" />}
        </div>

        {!simple && (
          <div className="ql-formats">
            <button type="button" className="ql-script" value="super" />
            <button type="button" className="ql-script" value="sub" />
          </div>
        )}

        {!simple && (
          <div className="ql-formats">
            <button type="button" className="ql-code-block" />
            <button type="button" className="ql-blockquote" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-direction" value="rtl" />
          <select className="ql-align" />
        </div>
      </div>
    </StyledEditorToolbar>
  )
);

Toolbar.displayName = 'Toolbar';

export default Toolbar;
